<template>
  <div>
    <job-content-table title="希望の指定">
      <job-content-table-outline-sub
        title="希望職種"
        :target-ids="targetIdMap.matching.desired.occupation.list"
        :contents="occupations"
        :comment-highlights="getAnyCommentHighlights(targetIdMap.matching.desired.occupation.prefix)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
      <job-content-table-outline
        title="希望業種"
        :target-id="targetIdMap.matching.desired.business"
        :value="createJoinedText(matching.desiredBusinessNameList)"
        :comment-highlights="getCommentHighlights(targetIdMap.matching.desired.business)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
      <job-content-table-outline
        title="希望勤務地"
        :target-id="targetIdMap.matching.desired.workPlace"
        :value="createJoinedText(matching.desiredWorkPlaceList)"
        :comment-highlights="getCommentHighlights(targetIdMap.matching.desired.workPlace)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
      <job-content-table-outline
        title="希望雇用形態"
        :target-id="targetIdMap.matching.desired.employment"
        :value="createJoinedText(matching.desiredEmploymentList)"
        :comment-highlights="getCommentHighlights(targetIdMap.matching.desired.employment)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      />
    </job-content-table>

    <job-content-table title="フリーワード">
      <job-content-table-outline
        title="フリーワード"
        :comment-highlights="getAnyCommentHighlights(targetIdMap.matching.freeWord.prefix)"
        :highlight-mode="highlightMode"
        data-test="freeWord"
        v-on="$listeners"
      >
        <template #body>
          <span>
            「職務経歴内容」「保有資格」「その他の外国語」「自己PR」から、フリーワード検索をおこないます。（400文字以内）<br>
            ※上記項目に登録がない会員は検索対象外となります。また、他の設定条件との掛け合わせでキーワードによってはマッチング条件が厳しくなりすぎる恐れがあります。<br>
            キーワード（スペース区切り）:<br>
          </span>
          <span
            :id="targetIdMap.matching.freeWord.word"
            class="pega-break"
            v-text="matching.freeWord || '未登録'"
          /><br>
          <span
            :id="targetIdMap.matching.freeWord.label"
            class="pega-break"
            v-text=" matching.freeWordSearchLabel || '未登録' "
          />
        </template>
      </job-content-table-outline>
    </job-content-table>

    <job-content-table title="活動履歴の指定">
      <job-content-table-outline
        title="新規会員の指定"
        :target-id="targetIdMap.matching.registrationDate"
        :value="matching.registrationDate"
        :comment-highlights="getCommentHighlights(targetIdMap.matching.registrationDate)"
        :highlight-mode="highlightMode"
        v-on="$listeners"
      >
        <br>
        <span>※検索する求職者（女の転職type会員）の対象範囲を指定してください。</span>
      </job-content-table-outline>
    </job-content-table>
  </div>
</template>

<script>
import JobContentTable from '@/components/atoms/JobContentTable'
import JobContentTableOutline from '@/components/atoms/JobContentTableOutline'
import JobContentTableOutlineSub from '@/components/molecules/JobContentTableOutlineSub'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'
import jobMatchingCommon from '@/lib/jobMatchingCommon'

export default {
  components: {
    JobContentTable,
    JobContentTableOutline,
    JobContentTableOutlineSub
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight, jobMatchingCommon],
  props: {
    matching: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    }
  }
}
</script>
